var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"gamanza-sidebar-wrapper",style:(_vm.collapsedClipStyle)},[_c('div',{staticClass:"gamification_widget",attrs:{"id":_vm.widgetId,"data-type":"sidebar"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }